define('SageDotCom/DataLayer/Events/Ccaas/ccaasAltEvent',[
        "jquery",
        "SageDotCom/DataLayer/Events/eventBase"
    ],
    function ($, EventBase) {
        function CcaaSAltEvent(action, category, label, name, level1, level2, level3, level4, nonInt, trigger) {
            EventBase.call(this);

            const eventAction = action;
            const eventCategory = category;
            const eventLabel = label;
            const eventName = name;
            const eventTrigger = trigger;
            const eventLevel1 = level1;
            const eventLevel2 = level2;
            const eventLevel3 = level3;
            const eventLevel4 = level4;
            const eventNonInt = nonInt || "0";

            this.props = {
                'event_action': eventAction,
                'event_category': eventCategory,
                'event_label': eventLabel,
                'event_name': eventName,
                'event_name_level_1': eventLevel1,
                'event_name_level_2': eventLevel2,
                'event_name_level_3': eventLevel3,
                'event_name_level_4': eventLevel4,
                'event_non-int': eventNonInt
            };

            if (trigger) {
                this.props.event_trigger = eventTrigger; 
            }
        }
        CcaaSAltEvent.prototype = Object.create(EventBase.prototype);
        return CcaaSAltEvent;
    });
